import {Signup as SignupZwinker} from "../../../Assets/ZwinkerNetworksSignup";

export function initFormHandler(signupUrl, failUrl, girlId, ws) {
	const form: HTMLFormElement = document.querySelector('#form');
	const email: HTMLInputElement = document.querySelector('#email');
	const checkboxAgb: HTMLInputElement = document.querySelector('#agb');
	const emailError: HTMLParagraphElement = document.querySelector('#email-error');
	const agbError: HTMLParagraphElement = document.querySelector('#agb-error');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		const agbIsChecked = checkboxAgb.checked;
		const emailValue = email.value;
		const emailIsValid = emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

		if (!emailIsValid) {
			emailError.removeAttribute('hidden');
		}
		if (!agbIsChecked) {
			agbError.removeAttribute('hidden');
		}

		if (agbIsChecked && emailIsValid) {
			SignupZwinker(signupUrl, email.value, failUrl, {profile: girlId, lp: 'MatchZWR', subsource: ws });
		}
	})
}
